import React, { useState } from "react";
import "./event.scss";


import img2 from "../../assets/events/25-26/2526 (3).jpeg";
import img3 from "../../assets/events/25-26/2526 (4).jpeg";
import img4 from "../../assets/events/25-26/2526 (5).jpeg";
import img5 from "../../assets/events/25-26/2526 (6).jpeg";
import img6 from "../../assets/events/25-26/2526 (7).jpeg";
import img7 from "../../assets/events/25-26/2526 (8).jpeg";
import img8 from "../../assets/events/25-26/2526 (9).jpeg";
import img9 from "../../assets/events/25-26/2526 (10).jpeg";
import img10 from "../../assets/events/25-26/2526 (11).jpeg";
import img11 from "../../assets/events/25-26/2526 (12).jpeg";
import img12 from "../../assets/events/25-26/2526 (13).jpeg";

const images = [ img2, img3, img4, img5, img6, img7, img8, img9, img10,img11,img12,];


function E2526() {
  const [selectedIndex, setSelectedIndex] = useState(null);
  
    const openImage = (index) => setSelectedIndex(index);
    const closeImage = () => setSelectedIndex(null);
  
    const showNext = () => {
      setSelectedIndex((prev) => (prev + 1) % images.length);
    };
  
    const showPrev = () => {
      setSelectedIndex((prev) => (prev - 1 + images.length) % images.length);
    };
  return (
    <>

    <div className="gallery">
      <div className="titel-head">
  <h1>MODEL PARLIAMENT 2025–26</h1>
  <p>
    Organised by <strong>KILPAR</strong> in association with
    <strong> Bengaluru Law College</strong>
  </p>
</div>

      {/* Image Grid */}
      <div className="images-grid">
        {images.map((src, index) => (
          <div className="img-card" key={index} onClick={() => openImage(index)}>
            <img src={src} alt={`Gallery ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedIndex !== null && (
        <div className="lightbox">
          <span className="close" onClick={closeImage}>
            &times;
          </span>
          <span className="prev" onClick={showPrev}>
            &#10094;
          </span>
          <img className="lightbox-img" src={images[selectedIndex]} alt="preview" />
          <span className="next" onClick={showNext}>
            &#10095;
          </span>
        </div>
      )}
    </div>

    </>
  )
}

export default E2526